(function () {
	const announcementSlider = () => {
		// Guard: check if Swiper library is loaded
		if (typeof Swiper === "undefined") {
			console.warn("❌ Swiper library not loaded. Make sure Swiper JS/CSS are included in theme.liquid");
			return;
		}

		console.log("✅ Swiper library loaded");

		// Get all announcement bar slide containers
		const announcementBars = document.querySelectorAll(".announcement-bar__slide");
		console.log(`Found ${announcementBars.length} announcement bar(s)`);

		announcementBars.forEach((bar) => {
			// Skip if already initialized
			if (bar.classList.contains("slider_started")) {
				console.log("Announcement already initialized, skipping...");
				return;
			}

			bar.classList.add("slider_started");

			const announcementId = bar.dataset.announcementId;
			const enableAutoplay = bar.dataset.autoplay === "true";
			const autoplayDelay = parseInt(bar.dataset.autoplayDelay) * 1000; // Convert to milliseconds

			if (!announcementId) {
				console.warn("❌ Missing announcement ID on slide container");
				return;
			}

			console.log(`Initializing announcement slider: ${announcementId}`);
			console.log(`Autoplay: ${enableAutoplay}, Delay: ${autoplayDelay}ms`);

			// Verify the swiper container exists
			const swiperContainer = document.querySelector(`.announcement-js-${announcementId}`);
			if (!swiperContainer) {
				console.warn(`❌ Swiper container not found: .announcement-js-${announcementId}`);
				return;
			}
			console.log(`✅ Swiper container found`);

			// Build Swiper config
			const swiperConfig = {
				loop: false,
				navigation: {
					nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
					prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
				},
			};

			// Add autoplay if enabled
			if (enableAutoplay) {
				swiperConfig.autoplay = {
					delay: autoplayDelay,
					disableOnInteraction: true, // Stop autoplay if user interacts (clicks arrow)
					pauseOnMouseEnter: true,    // Pause autoplay on hover
				};
			}

			try {
				const announcementSwiper = new Swiper(
					`.announcement-js-${announcementId}`,
					swiperConfig
				);
				console.log(`✅ Swiper initialized successfully for ${announcementId}`);
			} catch (error) {
				console.error(
					`❌ Failed to initialize Swiper for announcement ${announcementId}:`,
					error
				);
			}
		});
	};

	// Initialize on page load
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", announcementSlider);
	} else {
		announcementSlider();
	}

	// Re-initialize when section is loaded (theme editor)
	document.addEventListener("shopify:section:load", announcementSlider);
})();